import ListItemButton from '@mui/material/ListItemButton';
import Popper from '@mui/material/Popper';
import './menu.css'
import { MenuList, Grow, ClickAwayListener, Paper } from '@mui/material';
import { AGENT_LOGIN_URL } from '../../../utils/properties';
import { getParsedParentUserName } from '../../../services/auth-service';
import { useNavigate } from 'react-router-dom';
import { isSubAdmin } from '../../../services/auth-service';
import { useMemo } from 'react';

const appsMenuItem = [
    // { name: 'Agent Toolbar', action: 'agent-toolbar' },
    { name: 'Contact Manager', action: 'contact-manager' }
];

function AppsMenu(props) {
    const open = Boolean(props?.anchorEl || false);
    const navigate = useNavigate();
    const subAdmin = useMemo(() => isSubAdmin(), []);

    const appsMenuItems = subAdmin ? [{ name: 'Agent Toolbar', action: 'agent-toolbar' }, ...appsMenuItem] : appsMenuItem;

    const handleClose = () => {
        props?.handleClose();
    };

    const handleMenuItemClick = (action) => {
        try {
            if (action === 'agent-toolbar') {
                const parentUserName = getParsedParentUserName();
                const mappedAgent = localStorage.getItem('mappedAgent');
                const mappedPhoneNumber = localStorage.getItem('mappedPhoneNumber');
                const apiKey = localStorage.getItem('userKey');
                const agentUrl = new URL(AGENT_LOGIN_URL);
                agentUrl.searchParams.append('customer', parentUserName);
                agentUrl.searchParams.append('agentid', mappedAgent);
                agentUrl.searchParams.append('phoneNumber', mappedPhoneNumber);
                agentUrl.searchParams.append('apiKey', apiKey);
                agentUrl.searchParams.append('UserAgentMapping', true);
                agentUrl.searchParams.append('action', 'formLogin');
                agentUrl.searchParams.append('pin', '');
                agentUrl.searchParams.append('sip', true);
                props?.onAgentToolbarClick(agentUrl.toString());
            } else if (action === 'contact-manager') {
                navigate('/apps/contactManager');
            }
            handleClose();
        } catch (error) {
            console.log('error in handleMenuItemClick', error);
        }
    };

    return (
        <Popper
            open={open}
            anchorEl={props.anchorEl}
            placement="right"
            transition
        >
            {({ TransitionProps, placement }) => (
                <Grow
                    {...TransitionProps}
                    style={{
                        transformOrigin:
                            placement === 'bottom-start' ? 'left right' : 'left bottom',
                    }}
                >
                    <Paper
                        sx={{
                            marginLeft: '8px',
                            borderRadius: '8px',
                            boxShadow: '0px 4px 12px rgba(0, 0, 0, 0.06)',
                            border: '1px solid #E6E5E6',
                            maxHeight: '70vh !important',
                            overflowY: 'auto',
                        }}
                    >
                        <ClickAwayListener onClickAway={handleClose}>
                            <MenuList
                                id="appsMenu"
                                aria-labelledby="appsModule"
                            >
                                {appsMenuItems.map((item, index) => (
                                    <ListItemButton
                                        key={item.name}
                                        className='admin-menu-list'
                                        onClick={() => handleMenuItemClick(item.action)}
                                        sx={{
                                            fontWeight: 500,
                                            fontSize: '12px',
                                        }}
                                    >
                                        {item.name}
                                    </ListItemButton>
                                ))}
                            </MenuList>
                        </ClickAwayListener>
                    </Paper>
                </Grow>
            )}
        </Popper>
    );
}

export default AppsMenu; 